<template>
  <!-- 本月数据概况 柱状图 -->
  <div class="chart-bar" />
</template>

<script>
import * as echarts from 'echarts'
import { genMonthList } from '../utils/genValues'

export default {
  name: 'chart-bar',
  props: {
    chartData: {
      type: Object,
      required: true,
      // validator: (value) => {
      //   return Array.isArray(value.xAxisData) && Array.isArray(value.seriesData)
      // }
    }
  },
  data() {
    return {
      color: '#3398DB', // 默认柱状图颜色
    }
  },
  watch: {
    'chartData.xAxisData': {
      deep: true,
      handler() {
        this.update()
      }
    },
    'chartData.seriesData': {
      deep: true,
      handler() {
        this.update()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const chart = echarts.init(this.$el)
      window.addEventListener('resize', () => chart.resize())
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', () => chart.resize())
        chart.dispose()
      })
      this.chart = chart
      this.update()
    },
    update() {
      const seriesData = this.chartData.seriesData
      let xAxisData = this.chartData.xAxisData
      const {color, chartName} = this
      if (!xAxisData || !seriesData || !xAxisData.length || !seriesData.length) return
      xAxisData = genMonthList(xAxisData.length)
      const option = {
        color: [color],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '10px', // 上边距为0
          left: '3%', // 左边距
          right: '3%', // 右边距
          bottom: 0, // 下边距为0
          containLabel: true // 确保标签不会被裁剪
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.45)' // 坐标轴X轴线条颜色
            }
          },
          axisLabel: { // 坐标轴样式
            interval: 0, // 强制显示所有标签
            rotate: 0, // 如果标签过长，可以旋转显示
            fontSize: 10,
            color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} P', // 格式化y轴标签
            fontSize: 10,
            color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
          },
          splitLine: { // 网格线
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.15)',
              width: 1,
            }
          },
        },
        series: [{
          name: chartName,
          type: 'bar',
          barWidth: '15px',
          itemStyle: {
            // barBorderRadius: [5, 5, 0, 0],
            color: function (params) {
              const colors = ['#00cad2', '#00b6e7', '#00a6fe']
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: colors[0]},
                {offset: 0.5, color: colors[1]},
                {offset: 1, color: colors[2]},
              ])
            },
          },
          data: seriesData
        }]
      }

      this.chart.setOption(option)
    }
  }
}
</script>
